<template>
  <div id="contendedor-agregar-garantia-contrato">
    <v-form v-model="formularioValido" ref="editarGarantia">
      <v-card>
        <v-card-title class="secondary--text">
          Editar garantía
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <text-field
            v-model="garantia.concepto"
            cols="12"
            label="Concepto"
            >
            </text-field>
            <date-picker
              v-model="garantia.fechaInicio"
              label="Fecha de Inicio"
              cols="6"
            >
            </date-picker>
            <date-picker
              v-model="garantia.fechaTermino"
              label="Fecha de Termino"
              cols="6"
            >
            </date-picker>
            <text-area
              v-model="garantia.comentarios"
              cols="12"
              label="Comentarios"
              rows="3">
            </text-area>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarGarantia"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixGarantiasContratos from './mixGarantiasContrato';
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarGarantiaContrato',
  mixins: [mixGarantiasContratos],
  props: {
    garantiaEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextField,
    DatePicker,
    TextArea,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      garantia: {
        concepto: this.garantiaEditar.concepto,
        fechaInicio: this.garantiaEditar.fechaInicio,
        fechaTermino: this.garantiaEditar.fechaTermino,
        comentarios: this.garantiaEditar.comentarios,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarGarantia.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
